export function ProductCtrl (
  $rootScope,
  $scope,
  $window,
  inheritorApi,
  invoices,
  log,
  messages,
  orders,
  product_categories,
  product,
  productApi,
  reserved,
  serialNumbers,
  VehicleVisuals,
  vendorInvoices
) {

  $scope.invoices       = invoices;
  $scope.log            = log;
  $scope.orders         = orders;
  $scope.vendorInvoices = vendorInvoices;
  $scope.reserved       = reserved;
  $scope.serialNumbers  = serialNumbers;
  $scope.categories     = product_categories;

  $scope.product = product || {
    id                  : null,
    item_code           : null,
    description         : null,
    description2        : null,
    brand               : null,
    product_type        : 'S',
    vendor_id           : null,
    vendor_name         : null,
    quantity_on_hand    : null,
    dont_update_quantity: false,
    comment             : null,
    job_card_comment    : null,
    location            : null,
    retail_price        : null,
    price2              : null,
    price3              : null,
    price4              : null,
    cost                : null,
    cost_including_tax  : null,
    gst_free            : null,
    service             : null,
    allow_partial_qty   : null
  };

  if ($rootScope.Company.hasIntegration('vehicle-visuals')) {
    $scope.VehicleVisuals = new VehicleVisuals();
  }

  $scope.attachVehicleVisual = function () {
    $scope.VehicleVisuals.attachToProduct().then(data => {
      $scope.product.vehicle_visuals_name = data.title || data.en_AU;

      return $scope.VehicleVisuals.getInteractiveUrl(data);
    }).then(data => {
      $scope.product.vehicle_visuals_url = data.url;

      $scope.form.$setDirty();
    }).catch(err => {
      if (!$scope.product.vehicle_visuals_url) {
        $scope.product.vehicle_visuals_name = null;
      }

      messages.error(err);
    });
  };

  $scope.clearVehicleVisual = function () {
    $scope.product.vehicle_visuals_name = null;
    $scope.product.vehicle_visuals_url  = null;

    $scope.form.$setDirty();
  };

  $scope.viewVehicleVisual = function () {
    $window.open($scope.product.vehicle_visuals_url , '_blank');
  };

  inheritorApi.inheritCtrl('ProductLiteCtrl', $scope);

  $scope.isLaborNRMA = $rootScope.Company.isBrand('nrma')
    && $rootScope.Company.isNRMAUser('create_job_codes')
    && productApi.isLabor($scope.product);
};